import { axios } from '@/utils/request'

const api = {
  installLabel: '/master/installLabel',
  audit: '/backlog/audit',
}

export function getMyAudit (parameter) {
  return axios({
    url: api.audit + '/myAudit',
    method: 'get',
    params: parameter
  })
}


export const accessoryExport = api.accessory + '/export'